module.exports = __webpack_public_path__ + "img/yt-qiavax.4f4de3e6.png";